<template>
  <div class="landing-page-wrapper">
    <div class="landingpage-bg">
      <img class="img-landingpage-bg" src="../../../assets/img/landingpage-bg.png" alt="" />
    </div>
    <div class="landing-top-container">
      <div class="landing-logo">
        <img src="../../../assets/img/isupplier-logo.png" class="img-landing-logo" alt="" />
      </div>
      <div class="landing-logo">
        <!-- <img src="../../../assets/img/logo-smm.png" class="img-landing-smm-logo" alt="" /> -->
      </div>
    </div>
    <div class="landing-container">
      <legal-stepper />
    </div>
    <div class="landing-footer-container">
      <span style="color:#fff; text-align:center"
        >Developed by
        <span style="color:#fff; font-weight:bold">Sinergi Tuntas Solusi</span>.</span
      >
    </div>
    <GlobalLoading v-if="$store.state.modalStore.isGlobalLoading ||
      $store.state.level1.isLoading ||
      $store.state.landingpage.globalLoading
    " />
    <Notif v-if="$store.state.showModalNotif" />
  </div>
</template>
<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  name: 'instruction',
  data() {
    return {
      pick: '',
      errorMessage: null,
    }
  },
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    Notif: () => import('@/components/modal/Notification.vue'),
    LegalStepper: () => import('@/components/molecules/Stepper/LegalStepper.vue'),
  },
  async created() {
    const query = this.$get(this.$route, 'params.session')
    const req = this.$get(this.$route, 'params.id')
    const user = this.$get(this.$route, 'params.user')

    if (user) {
      await this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'userid',
        value: user,
      })
    }
    await this.setPage(query, req)
  },

  methods: {
    async setPage(query, req) {
      try {
        let url = ''
        if (query) url = `${api}/api/v1/request/session/${query}`
        if (req) url = `${api}/api/v1/request/detailvendor/${req}`

        let pendaftaran_id = null
        let bidang_usaha = ''
        let bidang_usaha_id = null
        let nama_vendor = ''
        let type_pendaftaran_id = null
        let register_gems = null
        let register_bce = null
        let register_bkes = null
        let request_id = null
        let vendor_ref = null
        let tujuan_pendaftaran_id = null

        const { data } = await axios({
          method: 'GET',
          url,
        })

        let dataStore = []

        if (req) {
          dataStore = data.data.items[0]
        }
        if (query) {
          dataStore = data.data
        }

        if (data && data.status == 'success') {
          pendaftaran_id = dataStore && dataStore.id
          bidang_usaha =
            dataStore && dataStore.bidang_usaha_id == 1 ? 'bu' : 'perorangan'
          bidang_usaha_id = dataStore && dataStore.bidang_usaha_id
          type_pendaftaran_id = dataStore && dataStore.type_pendaftaran_id
          register_gems = dataStore && dataStore.register_gems
          register_bce = dataStore && dataStore.register_bce
          register_bkes = dataStore && dataStore.register_bkes
          nama_vendor = dataStore && dataStore.nama_vendor
          request_id = dataStore && dataStore.request_id
          vendor_ref =
            dataStore && dataStore.request && dataStore.request.vendor_ref
          tujuan_pendaftaran_id = this.$get(
            data,
            'data.request.tujuan_pendaftaran'
          )
          if (type_pendaftaran_id == 1) {
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'choosedCountry',
              value: {
                id: 63,
                kode_negara: 'ID',
                negara: 'Indonesia',
                kode_telepon: '62',
                mata_uang: 'Rupiah ',
                kode_mata_uang: 'IDR',
                createdAt: '2021-12-07T07:15:27.000Z',
                updatedAt: '2021-12-07T07:15:27.000Z',
                deletedAt: null,
              },
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phoneCode',
              value: '+62',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'mataUang',
              value: 'IDR',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phoneDirektur',
              value: '+62',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phoneKomisaris',
              value: '+62',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phonePic',
              value: '+62',
            })
          }

          await this.$store.commit(
            'landingpage/SET_LANDING_ROUTER',
            bidang_usaha
          )
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'request_id',
            value: request_id,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'pendaftaran_id',
            value: pendaftaran_id,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'tujuan_pendaftaran_id',
            value: tujuan_pendaftaran_id,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'vendorName',
            value: nama_vendor,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'pemilikBank',
            value: nama_vendor,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'bidang_usaha_id',
            value: bidang_usaha_id,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'type_pendaftaran_id',
            value: type_pendaftaran_id,
          })

          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'register_gems',
            value: register_gems,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'register_bce',
            value: register_bce,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'register_bkes',
            value: register_bkes,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'vendor_ref',
            value: vendor_ref,
          })

          await this.$store.dispatch('landingpage/getAllForms')
          await this.$store.dispatch('landingpage/getAnswer')
          await this.checkRoutePath(request_id)
        }
      } catch (error) {
        await this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
        // await this.$router.push('/')
      }
    },
    async checkRoutePath(request_id) {
      let pageName = this.$route.path
      if (pageName && pageName.split('/')[1] == 'review-landing-page') {
        await this.$store.commit('landingpage/SET_NEED_REVIEW')
        await this.getInformasi(request_id)
      }

      if (pageName && pageName.split('/')[1] == 'review-from-landing-page') {
        await this.$store.commit('landingpage/SET_NEED_REVIEW')
        await this.getInformasi(request_id)
      }

      if (pageName && pageName.split('/')[1] == 'pra-legal') {
        await this.$store.commit('landingpage/SET_NEED_REVIEW')

        await this.getInformasi(request_id)
        await this.$store.commit('landingpage/PRA_LEGAL')
      }
    },
    async getInformasi(request_id) {
      let pageName = this.$route.path
      let isPraLegal = false
      let vendor_ref = this.$store.state.landingpage.vendor_ref

      let url = `${api}/api/v1/d-vendor-informasi?request_id=${request_id}`

      if (pageName && pageName.split('/')[1] == 'pra-legal') {
        url = `${api}/api/v1/d-vendor-informasi?id=${vendor_ref}`
        isPraLegal = true
      }

      await this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'globalLoading',
        value: true,
      })
      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          let informasi = data.data
          this.$store.commit('landingpage/UPDATE_INFORMASI', informasi)
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'globalLoading',
            value: false,
          })
          if (isPraLegal) {
            this.getLegalitas(vendor_ref, true)
          } else {
            this.getLegalitas(request_id, false)
          }
        })
        .catch(error => {
        })
    },
    getLegalitas(id, isPraLegal) {
      let url = `${api}/api/v1/d-vendor-legal-document?request_id=${id}`
      if (isPraLegal) {
        url = `${api}/api/v1/d-vendor-legal-document?vendor_id=${id}`
      }

      axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          let legal = data.data
          this.$store.commit('landingpage/UPDATE_LEGAL', legal)
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          // do nothing
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'globalLoading',
            value: false,
          })
        })
    },
  },
}
</script>
